import { create } from "zustand"
import { persist } from "zustand/middleware"

interface ImageSearchAnnouncementState {
  dismissedByUser: Record<number, boolean>
  dismiss: (userId: number) => void
}

export const useImageSearchAnnouncementStore = create<ImageSearchAnnouncementState>()(
  persist(
    (set) => ({
      dismissedByUser: {},
      dismiss: (userId) =>
        set((state) => ({
          dismissedByUser: { ...state.dismissedByUser, [userId]: true },
        })),
    }),
    { name: "imageSearchAnnouncement" }
  )
)
